export default "__VITE_ASSET__BxQm91dZ__"